import Icon from '../../components/Icon.vue';
Icon.register({
  'brands/sourcetree': {
    width: 448,
    height: 512,
    paths: [{
      d: 'M427.2 203c-0.1 90.2-59.2 166.7-140.7 193.1v101.6c0 7.9-6.4 14.3-14.3 14.3h-96.4c-7.9 0-14.3-6.4-14.3-14.3v-101.7c-81.5-26.3-140.5-102.8-140.5-193v-0.4c0.2-112 91.1-202.8 203.2-202.6 112.1 0 203 90.9 203 203zM155.6 203c0 91 137.2 89.9 137.3 0 0-90.8-137.3-90.8-137.3 0z'
    }]
  }
});